import React from "react";
import styled, { keyframes } from "styled-components";

function Button({ onClick, placeholder, loading, disabled }) {
  return (
    <BtnBody>
      <ButtonStyle
        disabled={disabled}
        style={{
          opacity: disabled && "0.8",
          cursor: disabled && "not-allowed",
        }}
        onClick={onClick}
      >
        {loading ? <Spinner /> : placeholder}
      </ButtonStyle>
    </BtnBody>
  );
}

export default Button;

const BtnBody = styled.div`
  width: 80%;
  margin: 0 auto;
`;

const ButtonStyle = styled.button`
  width: 100%;
  background-color: #ff993a;
  border: none;
  color: white;
  border-radius: 8px;
  padding: 20px 0;
  font-size: 15px;
  cursor: pointer;
  display: grid;
  place-items: center;
`;

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);

  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  border-left: 2px solid #04a3e5;
  background: transparent;
  width: 14px;
  height: 14px;
  border-radius: 50%;
`;
